import { useCallback, useEffect, useState } from "react";
import { LOCAL_USER_UPDATED_EVENT } from "@jti/fe-common";
import { getUser } from "@jti/rest-api";
export const useUser = () => {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const setUserData = useCallback(async () => {
        const user = getUser();
        setIsUserLoggedIn(Boolean(user?.uuid && user?.ciam_token));
        setUser(user);
    }, [setUser]);
    useEffect(() => {
        setUserData();
    }, [setUserData]);
    useEffect(() => {
        window.addEventListener(LOCAL_USER_UPDATED_EVENT, setUserData);
        return () => {
            window.removeEventListener(LOCAL_USER_UPDATED_EVENT, setUserData);
        };
    }, [setUserData]);
    return {
        user,
        isUserLoggedIn,
    };
};
//# sourceMappingURL=useUser.js.map